module.exports = __webpack_public_path__ + "static/media/Logo.c81d73a6.svg";